import React, { useEffect } from 'react';
import { IonModal, IonContent } from '@ionic/react';
import Button from '../../../../components/atoms/button';
import './InfoModal.css';

interface InfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  propertyNumber?: string;
  region_Name?: string;
  city_Name?: string;
  district_Name?: string;
  Parcel_Status?: string;
  plan_Id?: string;
  propertyAdvertisements?: any[];
  streetInfo?: any[];
  area?: string;
  directionParcel?: any[];
}

const InfoModal: React.FC<InfoModalProps> = ({
  isOpen,
  onClose,
  propertyNumber,
  region_Name,
  city_Name,
  district_Name,
  Parcel_Status,
  plan_Id,
  propertyAdvertisements,
  streetInfo,
  area,
  directionParcel,
}) => {

  return (
    <IonModal
      isOpen={isOpen}
      initialBreakpoint={0.7}
      breakpoints={[1, 1, 1, 1]}
      animated={true}
      onWillDismiss={onClose}
      trigger="open-custom-dialog"
    >
      <IonContent>
        <div className="w-full h-full pt-4 flex flex-col justify-start items-center">
          {/* Close button at top right */}
          <div className="w-full flex justify-end px-6 mb-2">
            <Button
              theme={"danger"}
              text={"إغلاق"}
              size={"small"}
              onClick={onClose}
            />
          </div>
          
          <p className="font-bold text-primaryColor100 text-2xl text-center mb-4">
            معلومات العقار
          </p>
          
          <div className="w-full px-6 text-right">
            <div className="bg-gray-50 rounded-lg p-4 mb-4">
              <h3 className="font-bold text-lg text-primaryColor100 mb-3">تفاصيل القطعة:</h3>
              <div className="grid grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <span className="text-sm text-gray-500 mb-1">رقم القطعة:</span>
                  <span className="text-gray-700 font-medium">{propertyNumber || "غير محدد"}</span>
                </div>
                <div className="flex flex-col">
                  <span className="text-sm text-gray-500 mb-1">المنطقة:</span>
                  <span className="text-gray-700 font-medium">{region_Name || "غير محدد"}</span>
                </div>
                <div className="flex flex-col">
                  <span className="text-sm text-gray-500 mb-1">المدينة:</span>
                  <span className="text-gray-700 font-medium">{city_Name || "غير محدد"}</span>
                </div>
                <div className="flex flex-col">
                  <span className="text-sm text-gray-500 mb-1">الحي:</span>
                  <span className="text-gray-700 font-medium">{district_Name || "غير محدد"}</span>
                </div>
              </div>
            </div>
            
            <div className="bg-blue-50 rounded-lg p-4 mb-4">
              <h3 className="font-bold text-lg text-primaryColor100 mb-3">معلومات إضافية:</h3>
              <div className="grid grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <span className="text-sm text-gray-500 mb-1">نوع العقار:</span>
                  <span className="text-gray-700 font-medium">{Parcel_Status || "غير محدد"}</span>
                </div>
                <div className="flex flex-col">
                  <span className="text-sm text-gray-500 mb-1">المخطط:</span>
                  <span className="text-gray-700 font-medium">{plan_Id || "غير محدد"}</span>
                </div>
                {propertyAdvertisements && propertyAdvertisements.length > 0 && (
                <div className="flex flex-col">
                  <span className="text-sm text-gray-500 mb-1">عدد الإعلانات:</span>
                  <span className="text-gray-700 font-medium">{propertyAdvertisements?.length || 0}</span>
                </div>
                )}
                <div className="flex flex-col">
                  <span className="text-sm text-gray-500 mb-1">المساحة:</span>
                  <span className="text-gray-700 font-medium">{area ? parseFloat(area).toFixed(2) : "غير محدد"}</span>
                </div>
              </div>
            </div>
            
            {streetInfo && streetInfo.length > 0 && (
              <div className="bg-yellow-50 rounded-lg p-4 mb-4">
                <h3 className="font-bold text-lg text-primaryColor100 mb-3">معلومات الشارع:</h3>
                {streetInfo.map((street, index) => (
                  <div key={index} className="grid grid-cols-3 gap-4 mb-3">
                    <div className="flex flex-col">
                      <span className="text-sm text-gray-500 mb-1">اسم الشارع:</span>
                      <span className="text-gray-700 font-medium">{street.streetname || "غير محدد"}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="text-sm text-gray-500 mb-1">كود الشارع:</span>
                      <span className="text-gray-700 font-medium">{street.streetcode || "غير محدد"}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="text-sm text-gray-500 mb-1">عرض الشارع:</span>
                      <span className="text-gray-700 font-medium">{street.streetwidth || street.streetwitdth || "غير محدد"}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
            
            {directionParcel && directionParcel.length > 0 && (
              <div className="bg-purple-50 rounded-lg p-4 mb-4">
                <h3 className="font-bold text-lg text-primaryColor100 mb-3">اتجاهات القطعة:</h3>
                {directionParcel.map((direction, index) => (
                  <div key={index} className="grid grid-cols-2 gap-4 mb-3">
                    <div className="flex flex-col">
                      <span className="text-sm text-gray-500 mb-1">الاتجاه:</span>
                      <span className="text-gray-700 font-medium">{direction.direction || "غير محدد"}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="text-sm text-gray-500 mb-1">الطول:</span>
                      <span className="text-gray-700 font-medium">{direction.length || "غير محدد"}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
            
            <div className="bg-green-50 rounded-lg p-4">
              <h3 className="font-bold text-lg text-primaryColor100 mb-2">ملاحظات:</h3>
              <p className="text-gray-700 text-sm leading-relaxed">
                هذه القطعة متاحة للعرض والاستكشاف. يمكنك استخدام الأدوات المتاحة للتنقل 
                وإضافة القطعة إلى المفضلة أو محفظة العقارات الخاصة بك.
              </p>
            </div>
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
};

export default InfoModal;
